import { SUBSCRIPTION_STATUS } from "api/interfaces/subscription.interface";
import { getAccountTimeFormatDate } from "utils/timeUtil";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import {
  getEffectiveStatus,
  getExpiredTooltipText,
} from "utils/SubscriptionUtil";
import StatusAlertBox from "./StatusAlertBox";
import { WithTooltip } from "components/blocks/WithTooltip";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { BiArrowFromLeft } from "react-icons/bi";

type Props = {
  status: SUBSCRIPTION_STATUS;
  expiredDate: string;
  extendTargetKey?: string;
  hideIcon?: boolean;
};

export default function ExpiredDate({
  status,
  expiredDate,
  extendTargetKey,
  hideIcon = false,
}: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  // extendTargetKey 가 있으면 만료 경고 상태를 무시하고 ACTIVATED 로 표시
  const effectiveStatus = getEffectiveStatus(status, extendTargetKey);
  const tooltip = getExpiredTooltipText(effectiveStatus);

  return (
    <StatusAlertBox
      status={effectiveStatus}
      showAlert={!!tooltip && !hideIcon}
      tooltip={tooltip}
    >
      {getAccountTimeFormatDate(expiredDate, {
        ...selectedAccount,
      })}
      {extendTargetKey && !hideIcon && (
        <WithTooltip tooltip={`Extended ${extendTargetKey}`}>
          <ExtendedIconBadge>
            <BiArrowFromLeft size={12} />
          </ExtendedIconBadge>
        </WithTooltip>
      )}
    </StatusAlertBox>
  );
}

const ExtendedIconBadge = styled.span`
  ${FLEX.FlexCenterCenter};
  padding: 1px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.COLORS.BUTTONS2};
  color: ${COLORS.WHITE};
  cursor: pointer;
`;
